package org.beatonma.orbitals.core

object OrbitalsBuildConfig {
    const val DEBUG: Boolean = false
}
